import _ from 'lodash';
import connect from 'components/lib/connect';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import ApiTokens from 'models/location/api_tokens';
import InsetContainer from 'components/common/containers/inset_container';
import Link from 'components/common/link';
import LookupApi from 'models/location/integrations/lookup_api';
import WebhooksAdmin from 'models/location/integrations/webhooks_admin';
import { getLocationUrl } from 'scripts/adapters/routes/location_url';
import { H1 } from 'components/common/headers';

const NavContainer = styled.div`
  display: flex;
  width: 100%;
`;

const NavWrapper = styled(InsetContainer)`
  border-right: 1px solid ${p => p.theme.colors.gray300};
  height: 100%;
  min-width: 250px;
  overflow-y: auto;
  position: fixed;
  width: 320px;
`;

const NavPage = styled.div`
  margin-left: 320px;
  width: 100%;
`;

const NavLink = styled(Link)`
  color: ${p => p.theme.colors.gray900};
  cursor: pointer;
  flex-direction: row;
  justify-content: space-between;
  padding: ${p => p.theme.spacing.stackSmall} ${p => p.theme.spacing.inlineMedium};
  &:hover {
    color: ${p => p.theme.colors.green400};
  }
`;

const SelectedNavLink = styled(NavLink)`
  background-color: ${p => p.theme.colors.green100};
  color: ${p => p.theme.colors.black};
`;

const NavHeader = styled(H1)`
  display: flex;
  margin-top: ${p => p.theme.spacing.inlineXLarge};
  padding-left: ${p => p.theme.spacing.inlineMedium};
`;

class IntegrationsNav extends React.Component {
  constructor(props) {
    super(props);
    this.placeholder = this.placeholder.bind(this);
  }

  placeholder() {
    return null;
  }

  render() {
    const integrationsPages = this.props.hasDevManagement
      ? [
          { location: ApiTokens, name: 'API Tokens' },
          { location: LookupApi, name: 'Customer Lookup API' },
          { location: WebhooksAdmin, name: 'Webhooks' },
        ]
      : [{ location: LookupApi, name: 'Customer Lookup API' }];

    if (this.props.shouldHideLookup) {
      _.remove(integrationsPages, o => o.name === 'Customer Lookup API');
    }

    return (
      <NavContainer className="integrations">
        <NavWrapper inset="none">
          <NavHeader stack="medium">Integrations</NavHeader>
          {_.map(integrationsPages, page => {
            let NavLinkComponent = this.props.currentLocation instanceof page.location ? SelectedNavLink : NavLink;
            return (
              <NavLinkComponent key={page.name} href={getLocationUrl(page.location.create())}>
                {page.name}
              </NavLinkComponent>
            );
          })}
        </NavWrapper>
        <NavPage>{this.props.children}</NavPage>
      </NavContainer>
    );
  }
}

export { IntegrationsNav, SelectedNavLink };

IntegrationsNav.propTypes = {
  currentLocation: PropTypes.object.isRequired,
  children: PropTypes.node,
  hasDevManagement: PropTypes.bool.isRequired,
  shouldHideLookup: PropTypes.bool.isRequired,
};

function mapStateToProps({ getProvider }) {
  let appFeatures = getProvider('appFeatures').get();
  const currentLocation = getProvider('currentLocation').get();
  const lookupStatus = getProvider('externalCustomerLookupStatus').get();

  return {
    currentLocation,
    hasDevManagement: appFeatures.isEnabled('devManagement'),
    shouldHideLookup: lookupStatus.hasConnector || !appFeatures.isEnabled('integrationsManagement'),
  };
}

const IntegrationsNavContainer = connect(mapStateToProps, null)(IntegrationsNav);
export default IntegrationsNavContainer;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/integrations/integrations_nav.jsx